import { useQuery } from '@tanstack/react-query';
import { AuthRequiredError, unwrap } from '@truecare/api-client';
import { api } from '../api';

/**
 * Fetches `/api/v1/me/facility/profile` — the facility the signed-in user
 * belongs to. Returns `null` if the user has no FACILITY_USER persona
 * (the backend 404s with `reason: 'no_facility_membership'`).
 *
 * Consumers should gate the call on `me.roles.some(r => r.persona ===
 * 'FACILITY_USER')` via the `enabled` flag so we don't 404 for every
 * non-facility user.
 */
export function useCurrentFacility(opts: { enabled: boolean }) {
  return useQuery({
    queryKey: ['facility', 'me'],
    queryFn: async () => {
      try {
        return await unwrap(api.GET('/api/v1/me/facility/profile'));
      } catch (err) {
        if (err instanceof AuthRequiredError) return null;
        throw err;
      }
    },
    enabled: opts.enabled,
    retry: false,
  });
}
